import { type ReactNode } from 'react';
import { Box } from '@terra/ui-styled-system';

export type EvidenceCardMediaSectionProps = {
  media?: ReactNode;
};

export function EvidenceCardMediaSection({
  media,
}: EvidenceCardMediaSectionProps) {
  if (!media) {
    return null;
  }

  return (
    <Box
      px={3}
      py={2}
      borderTopWidth="1px"
      borderTopColor="border.neutral.muted"
      bg="bg.subtle"
    >
      {media}
    </Box>
  );
}
